import { type Locale } from 'date-fns';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getBenLanguageLocale, parseBenLanguageCode } from '../languages';

export const useLocale = () => {
  const { i18n } = useTranslation();

  const languageCode = useMemo(() => {
    const i18nLanguage = i18n.language;
    return parseBenLanguageCode(i18nLanguage);
  }, [i18n.language]);

  const locale: Locale = useMemo(() => {
    return getBenLanguageLocale(languageCode);
  }, [languageCode]);

  return { i18nLanguage: i18n.language, locale, languageCode };
};
